(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('StorePageCtrl', StorePageCtrl);

  // @ngInject
  function StorePageCtrl($injector, $state, Auth, userStores, LookAndFeel, Nav, AnalyticsHelper, LookAndFeelType) {
    var vm = this;

    vm.goToBrandMetrics = function() {
      AnalyticsHelper.sendViewChangeEvent(LookAndFeelType.BrandMetrics);
      $state.go(vm.brandMetricsState);
    };

    // setting lookAndFeel to BrandMetrics initially to get first available state in BrandMetrics which would be
    // used to toggle from Analytics to BrandMetrics
    LookAndFeel.setToBrandMetrics();
    var brandMetricsFirstMenuItem = _.find(Nav.mainMenu(), function (menuItem) {
      return $injector.invoke(menuItem.canAccess) && menuItem.isBrandMetric;
    });
    vm.brandMetricsState = brandMetricsFirstMenuItem && brandMetricsFirstMenuItem.state.name();

    //setting lookAndFeel to StoreReporting so that only store reporting menu items would be seen on UI
    LookAndFeel.setToAnalytics();
    vm.user = Auth.getUser();
    vm.userStores = userStores;

  }
  })();
